import UpdateBorrowingContent from "../../content/borrowing/updateBorrowing";
import { Layout } from "../../layout/page";

export function UpdateBorrowing() {
  return (
    <Layout>
      <UpdateBorrowingContent />
    </Layout>
  );
}
